import React from 'react';
import { Box, Grid, Hidden, Typography } from '@material-ui/core';
import clsx from 'clsx';
import DoneIcon from '@material-ui/icons/Done';
import { useStyles } from './style';

const SuccessStep = ({ selected }) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12} lg={7} className={classes.marginCenter}>
        <Box className={classes.box}>
          <Grid item xs={12}>
            <Typography variant='h2' className={classes.formTitle}>
              Dziękujemy za Twój głos
            </Typography>
            <Typography className={classes.withMarginBottom}>
              Dziękujemy za głosowanie na projekty:
              <ul>
                {selected.map((item) => (
                  <li>{item.title}</li>
                ))}
              </ul>
              <br />
              Teraz czekamy na wyniki!
            </Typography>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SuccessStep;
